export class ProductCard {
    static ACTIVE = "ACTIVE";
    static UPCOMING = "UPCOMING";
    static DISABLED = "DISABLED";
    static DELETED = "DISABLED";

    static DIALOG_REFERRAL_LINK = "DIALOG_REFERRAL_LINK";
    static DIALOG_QR_CODE = "DIALOG_QR_CODE";
}

export class SocialMedia {
    static WHATSAPP_URL = "https://api.whatsapp.com/send?phone=&text=";
    static FACEBOOK_URL = "https://www.facebook.com/sharer.php?u=";
}

export class Errors {
    static COPY_FAILURE = "Copy failure. Does not work for non HTTPS site.";
    static LINK_GEN_FAILURE = "Sorry something went wrong. Please try again.";
    static SHARE_COUNT_EXCEED= "You have exceeded your monthly referral quota.";
}